import { useEffect, useState } from 'react';
import ManifoldLogo from '../general/ManifoldLogo';
import { StatCell, StatsContainer } from '../general/StatCells';

function FoldStats() {
  const [totalStaked, setTotalStaked] = useState(0);
  const [currentAPY, setCurrentAPY] = useState(0);
  const [numberOfStakers, setNumberOfStakers] = useState(0);

  // Mock, for now
  useEffect(() => {
    setTimeout(
      () => {
        setTotalStaked(31131);
        setCurrentAPY(1.51);
        setNumberOfStakers(1131);
      },
      Math.random() * 1000 + 500,
    );
  }, []);

  const didLoad = totalStaked > 0 && currentAPY > 0 && numberOfStakers > 0;
  return (
    <StatsContainer>
      <StatCell
        Logo={ManifoldLogo}
        didLoad={didLoad}
        title="Total Staked"
        subtitle={`${totalStaked.toLocaleString()}`}
      />
      <StatCell didLoad={didLoad} title="Current APY" subtitle={`${currentAPY}%`} />
      <StatCell
        didLoad={didLoad}
        title="# of Stakers"
        subtitle={`${numberOfStakers.toLocaleString()}`}
      />
    </StatsContainer>
  );
}

export default FoldStats;
